(() => {
function init(root=document) {
root.querySelectorAll('[data-sd-product]').forEach(section => {
 if(section.dataset.ready) return; section.dataset.ready='true';
 const quantity=section.querySelector('[name="quantity"]');
 const thumbs=[...section.querySelectorAll('[data-photo]')];
 const variantSelect=section.querySelector('[data-sd-variant]');
 let productImages;
 async function syncVariantPhoto(){
  if(!variantSelect)return;
  const selectedId=variantSelect.value;
  try{
   if(!productImages)productImages=fetch(location.pathname.replace(/\/$/,'')+'.js',{headers:{Accept:'application/json'}}).then(response=>{if(!response.ok)throw new Error('Product images unavailable');return response.json();});
   const product=await productImages;
   if(variantSelect.value!==selectedId)return;
   const variant=product.variants.find(item=>String(item.id)===selectedId);
   const source=variant?.featured_image?.src;
   if(!source)return;
   const filename=url=>new URL(url,location.origin).pathname.split('/').pop();
   const matchingThumb=thumbs.find(thumb=>filename(thumb.dataset.photo)===filename(source));
   if(matchingThumb)matchingThumb.click();
  }catch(error){productImages=null;}
 }
 section.addEventListener('change',event=>{if(event.target.matches('select'))setTimeout(syncVariantPhoto,0);});
 setTimeout(syncVariantPhoto,0);
 section.addEventListener('change',event=>{
  if(event.target.name==='bundle_choice'){const mixed=event.target.value!=='1';section.querySelector('.sd-qty').hidden=mixed;quantity.value='1';}
  if(event.target===quantity){const single=section.querySelector('[name="bundle_choice"][value="1"]');if(single)single.checked=true;}
  if(event.target.matches('[data-sd-variant]')) { const option=event.target.selectedOptions[0]; section.querySelector('[data-sd-price]').textContent=option.dataset.price; section.querySelectorAll('[data-sd-estimate]').forEach(el=>{const n=Number(el.dataset.sdEstimate);el.textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:section.dataset.currency}).format(Math.round(Number(option.dataset.cents)*n*(n>=5?.7:1))/100);}); }
 });
 section.addEventListener('click',event=>{
  const step=event.target.closest('[data-sd-step]');
  if(step){Number(step.dataset.sdStep)>0?quantity.stepUp():quantity.stepDown();quantity.dispatchEvent(new Event('change',{bubbles:true}));}
  const nav=event.target.closest('[data-sd-photo-step]');
  if(nav && thumbs.length>1){const active=thumbs.findIndex(el=>el.getAttribute('aria-pressed')==='true');thumbs[(active+Number(nav.dataset.sdPhotoStep)+thumbs.length)%thumbs.length].click();}
  const thumb=event.target.closest('[data-photo]');
  if(thumb){const concept=thumb.dataset.concept==='true';section.querySelectorAll('[data-concept-label]').forEach(label=>label.hidden=!concept);section.querySelector('.sd-main-photo').dataset.conceptActive=String(concept);const photo=section.querySelector('.sd-active-photo');photo.removeAttribute('srcset');photo.src=thumb.dataset.photo;photo.alt=thumb.dataset.alt;section.querySelectorAll('[data-photo]').forEach(el=>el.setAttribute('aria-pressed',String(el===thumb)));const counter=section.querySelector('[data-sd-photo-count]');if(counter)counter.textContent=String(thumbs.indexOf(thumb)+1).padStart(2,'0')+' / '+thumbs.length;}
  const dialog=section.querySelector('dialog');
  if(event.target.closest('.sd-enlarge')){const photo=section.querySelector('.sd-active-photo');const zoom=dialog.querySelector('img');if(photo&&zoom){zoom.removeAttribute('srcset');zoom.src=photo.src;zoom.alt=photo.alt;const disclosure=dialog.querySelector('[data-concept-label]');if(disclosure)disclosure.hidden=section.querySelector('.sd-main-photo').dataset.conceptActive!=='true';dialog.showModal();}}
  if(event.target.closest('[data-sd-close]')||event.target===dialog) dialog.close();
 });
});
}
function stickyUpdate(){document.querySelectorAll('[data-sd-sticky]').forEach(sticky=>{const section=sticky.closest('.shopify-section');const buy=section?.querySelector('.sd-buy-form');if(buy)sticky.hidden=buy.getBoundingClientRect().bottom>0;});}
document.addEventListener('scroll',stickyUpdate,{passive:true,capture:true});window.addEventListener('resize',stickyUpdate);stickyUpdate();
if(new URLSearchParams(location.search).get('squish_open_bag')==='1'){
 customElements.whenDefined('cart-drawer').then(()=>{
 const drawer=document.querySelector('cart-drawer');
 if(drawer){drawer.refreshCartDrawer();const url=new URL(location.href);url.searchParams.delete('squish_open_bag');history.replaceState(null,'',url);}
 });
}
init(); document.addEventListener('shopify:section:load',event=>init(event.target));
})();

// Keep the native Kaching fetch integration while rendering the existing drawer.
(() => {
 if(window.squishKachingDrawerBound)return;
 window.squishKachingDrawerBound=true;
 document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches?.('.sd-buy-form')||event.defaultPrevented)return;
  event.preventDefault();
  if(form.dataset.drawerBusy)return;
  form.dataset.drawerBusy='true';
  const button=form.querySelector('button[type=submit]');
  const status=form.querySelector('.sp-form-status');
  const label=button?.textContent;
  let added=false;
  try{
   const drawer=document.querySelector('cart-drawer');
   if(!drawer)throw new Error('Your bag is still loading. Please try again.');
   const data=new FormData(form);
   data.delete('return_to');
   data.set('sections','cart-drawer,cart-icon-bubble');
   data.set('sections_url',location.pathname);
   drawer.setActiveElement(button);
   if(button){button.disabled=true;button.textContent='Adding…';}
   if(status)status.textContent='';
   const response=await window.fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok||result.status)throw new Error(result.description||'Please choose every item in your bundle and try again.');
   added=true;
   await drawer.renderContents(result);
   if(status)status.textContent='Added to your bag.';
  }catch(error){if(status)status.textContent=added?'Added to your bag. Open your bag to view it.':error.message;}
  finally{delete form.dataset.drawerBusy;if(button){button.disabled=false;button.textContent=label;}}
 });
})();

// Add concise offer labels without changing Kaching's prices or selections.
(() => {
 const offers={5:['SAVE 30%','A little collection of favourites.'],6:['SAVE 35%','More textures to mix and match.'],8:['SAVE 40%','A bigger mix to share or keep.']};
 const decorate=()=>document.querySelectorAll('.sd-buy-form .kaching-bundles__bar-first-line').forEach(row=>{
  const title=row.querySelector('.kaching-bundles__bar-title');
  const count=title&&Number(title.textContent.trim().match(/^([568]) items$/)?.[1]);
  if(!offers[count])return;
  let badge=row.querySelector('.sp-bundle-saving');
  if(!badge){badge=document.createElement('em');badge.className='sp-bundle-saving';row.append(badge);}
  if(badge.textContent!==offers[count][0])badge.textContent=offers[count][0];
  let sub=row.parentElement.querySelector('.sp-bundle-subtitle');
  if(!sub){sub=document.createElement('p');sub.className='sp-bundle-subtitle';row.after(sub);}
  if(sub.textContent!==offers[count][1])sub.textContent=offers[count][1];
 });
 const start=()=>{document.querySelectorAll('.sd-buy-form kaching-bundle').forEach(el=>new MutationObserver(decorate).observe(el,{childList:true,subtree:true}));decorate();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();

// Filter the native product picker without changing bundle selections or prices.
(() => {
 const pickerSelector='.kaching-bundles__choose-product';
 const cardSelector='.kaching-bundles__choose-product__product';
 const styles=[['all','All styles'],['crunchy','Crunchy'],['slushy','Slushy'],['soft','Soft squish'],['coconut','Coconut Oil']];
 // Visual style grouping reviewed from product images; not a material certification.
 const coconutStyles=new Set(["glacier-cheese-squishy", "vaseline-apple-squishy", "toothpaste-squishy-pink", "rose-bottle-keychain-squishy", "mixed-fruit-apple-squishy", "honeycomb-apple-squishy", "honeycomb-bottle-squishy", "ocean-pearl-bottle-squishy", "ocean-pearl-apple-squishy", "ocean-shell-bottle-squishy", "mini-red-apple-squishy", "glitter-apple-squishy", "glitter-toothpaste-squishy-green"]);
 const classify=card=>{
  const link=card.querySelector('a[href*="/products/"]');
  const handle=link?.getAttribute('href').split('/products/')[1]?.split(/[?#/]/)[0]||'';
  if(handle.includes('coconut-oil')||coconutStyles.has(handle))return 'coconut';
  if(/crunchy|chocolate-brick/.test(handle))return 'crunchy';
  if(/slushy|strawberry-smoothie|orange-beaded/.test(handle))return 'slushy';
  return 'soft';
 };
 const apply=picker=>{
  const select=picker.querySelector('[data-sp-style-select]');
  if(!select)return;
  let shown=0,total=0;
  picker.querySelectorAll(cardSelector).forEach(card=>{
   const style=classify(card),hide=select.value!=='all'&&select.value!==style;
   card.classList.toggle('sp-style-filtered-out',hide);
   total++;if(!hide)shown++;
  });
  const count=picker.querySelector('[data-sp-style-count]');
  const text=shown?`${shown} ${shown===1?'squishy':'squishies'}`:'No squishies in this style.';
  if(count.textContent!==text)count.textContent=text;
 };
 const enhance=()=>document.querySelectorAll(pickerSelector).forEach(picker=>{
  const list=picker.querySelector('.kaching-bundles__choose-product__products');
  if(!list)return;
  if(!picker.querySelector('[data-sp-style-select]')){
   const bar=document.createElement('div');bar.className='sp-picker-style-filter';
   const label=document.createElement('label');label.textContent='Shop by style';
   const select=document.createElement('select');select.dataset.spStyleSelect='';select.setAttribute('aria-label','Shop by style');
   styles.forEach(([value,text])=>{const option=document.createElement('option');option.value=value;option.textContent=text;select.append(option);});
   label.append(select);
   const count=document.createElement('span');count.dataset.spStyleCount='';count.setAttribute('role','status');count.setAttribute('aria-live','polite');
   bar.append(label,count);list.before(bar);
   select.addEventListener('change',()=>apply(picker));
  }
  apply(picker);
 });
 let queued=false;
 const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;enhance();});};
 const start=()=>{new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});enhance();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
